import { useState, type InputHTMLAttributes } from "react";
import { useI18n } from "../i18n";

/** Password field with a show / hide toggle (same look as a normal input). */
export function PasswordInput({ value, onChange, autoComplete = "new-password", ...rest }: { value: string; onChange: (v: string) => void } & Omit<InputHTMLAttributes<HTMLInputElement>, "value" | "onChange" | "type">) {
  const { t } = useI18n();
  const [show, setShow] = useState(false);
  return (
    <span className="pw-input">
      <input {...rest} type={show ? "text" : "password"} autoComplete={autoComplete} value={value} onChange={(e) => onChange(e.target.value)} autoCapitalize="off" spellCheck={false} />
      <button type="button" className="pw-toggle" onClick={() => setShow((s) => !s)} aria-pressed={show} aria-label={show ? t("iv.pw.hide") : t("iv.pw.show")} title={show ? t("iv.pw.hide") : t("iv.pw.show")}>
        {show
          ? <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden><path fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" d="M3 3l18 18M10.6 10.6a2 2 0 0 0 2.8 2.8M9.9 5.1A9.8 9.8 0 0 1 12 5c5 0 9 4.5 10 7-.4 1-1.3 2.4-2.6 3.7M6.6 6.6C4.6 7.9 3.1 9.9 2 12c1 2.5 5 7 10 7 1.6 0 3.1-.4 4.4-1.1" /></svg>
          : <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden><path fill="none" stroke="currentColor" strokeWidth="2" d="M2 12c1-2.5 5-7 10-7s9 4.5 10 7c-1 2.5-5 7-10 7S3 14.5 2 12z" /><circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="2" /></svg>}
      </button>
    </span>
  );
}

/** Same rule as the server (validatePasswordStrength): 10+ characters, letters and numbers. */
export const passwordStrongEnough = (pw: string) => pw.length >= 10 && pw.length <= 256 && /[a-z]/i.test(pw) && /\d/.test(pw);
